import { Container, TextLink } from '../components/ui';
import usePageMeta from '../hooks/usePageMeta';

export default function NotFound() {
  usePageMeta('Page not found — Timothy Gilbert');
  return (
    <Container className="py-16 md:py-24">
      <h1 className="font-display text-h1">Page not found</h1>
      <p className="mt-6 max-w-measure font-body text-lead">That address doesn’t exist on this site.</p>
      <p className="mt-6 font-display font-medium">
        <TextLink to="/">Back to portfolio</TextLink>
      </p>
    </Container>
  );
}
